import { WidgetDataSource } from '../../../../../../../models';
import {
  Comparison,
  SectionFilter,
  Widget,
  WidgetGroup,
} from '../../../../../../../providers/bridge-api/dashboard.service';
import { Utils } from '../../../../../../../utils/utils';
import { WidgetChartOptions } from '../../../../widget-chart/widget-chart.component';
import { AiInsightPayloadParams } from './widget-ai-insights-point-selection.service';
import { WidgetPointSelection } from './widget-point-selection';

export class SentimentVsVolumePointSelection extends WidgetPointSelection {
  override assemblePayloadFromSelection(
    selectedPoints: any[],
    widget: Widget<WidgetChartOptions>,
    dataSource: WidgetDataSource,
    widgetGroup?: WidgetGroup,
    comparison?: Comparison,
    sectionFilter?: SectionFilter[]
  ): AiInsightPayloadParams {
    const payload = super.assemblePayloadFromSelection(
      selectedPoints,
      widget,
      dataSource,
      widgetGroup,
      comparison,
      sectionFilter
    );

    const flattenedPoints = selectedPoints.flatMap((p) => p);
    for (let pointIdx = 0; pointIdx < flattenedPoints.length; pointIdx++) {
      const bucket = payload.buckets[pointIdx];
      const point = flattenedPoints[pointIdx];

      bucket.analytic_item_value = widget.payload.selectedItems[0];

      if (point.series.name !== 'total') {
        bucket.sentiment = point.series.name;
        bucket.aggregate_rating_score = Utils.round(point.y * 100, 2);
      }
    }

    return payload;
  }

  protected override fillWidgetQueryOptionsForPoint(widgetQueryOptions: any, point: any): void {
    super.fillWidgetQueryOptionsForPoint(widgetQueryOptions, point);

    widgetQueryOptions.widgetContextMenu.category = point.category;
    widgetQueryOptions.widgetContextMenu.series = point.series;
    widgetQueryOptions.widgetContextMenu.index = point.index;
  }
}
